
















































































import { Component,	Vue, Prop } from 'vue-property-decorator';

import { bus } from '@/main'
import GlobalMixins from '@/mixins'
import ConfettiCanon from '@/components/ConfettiCanon.vue'

@Component({
	components: {
		ConfettiCanon
	}
})
export default class Results extends GlobalMixins {
	results: any = this.$store.getters.data.results
	questions: any = this.$store.getters.data.questions
	userChoices: any = this.$store.getters.userChoices
	resultsOpen: boolean[] = []
	confettiLeft: any = {
		angle: '45',
		spread: '70',
		startVelocity: '100',
		elementCount: '90',
		dragFriction: '0.13',
		duration: 4000,
		stagger: '2',
		width: '12px',
		height: '12px',
		colors: ["#FF4767", "#1AA8B5"]
	}
	confettiRight: any = {
		angle: '135',
		spread: '70',
		startVelocity: '100',
		elementCount: '90',
		dragFriction: '0.13',
		duration: 4000,
		stagger: '2',
		width: '12px',
		height: '12px',
		colors: ["#FF4767", "#1AA8B5"]
	}

	get headerMessage(): string {
		let headerMessage = ''
		let filteredMessages = this.results.headerMessages

		filteredMessages = filteredMessages.filter((message: any) => this.itemConditionCheck(message))

		if (filteredMessages.length === 1 && this.filteredResults.length > 0) {
			headerMessage = filteredMessages[0].text
			headerMessage = headerMessage.replace('$itemAmount', `<span class="header__message-amount">${this.filteredResults.length}</span>`)
		}

		return headerMessage
	}
	get filteredResults(): any {
		let filteredResults = this.results.infoItems

		filteredResults = filteredResults.filter((result: any) => this.itemConditionCheck(result))

		return filteredResults
	}

	itemConditionCheck(item: any): boolean {
		if (!item.conditions) {
			return true
		}

		const conditionsMet = [...item.conditions].map((condition: any) => {
			
			const question = this.questions[(condition.questionId - 1)]

			if (question.type !== 'form') {
				const questionWasCorrect = this.answerIsCorrect(question, condition.questionId)

				return (questionWasCorrect === condition.answer)
			} else {
				if (condition.answer.bmi) {
					let weight = this.userChoices[condition.questionId - 1][condition.answer.nameOfInputs.weight.name]
					let height = this.userChoices[condition.questionId - 1][condition.answer.nameOfInputs.height.name]
					
					switch (condition.answer.nameOfInputs.weight.unit) {
						case 'lbs':
							weight = weight / 2.205
							break
						case 'stone': 
							weight = weight * 6.35
							break
						case 'kg':
							break
					}

					switch (condition.answer.nameOfInputs.height.unit) {
						case 'cm':
							height = height / 100
							break
						case 'ft': 
							height = height / 3.333
							break
						case 'm':
							break
					}

					const bmi = weight / (height * height)

					return ((bmi > condition.answer.min && bmi < condition.answer.max) === condition.answer.value)
				} else {
					let userAnswerOfFormField = this.userChoices[condition.questionId - 1][condition.answer.name]

					const formFieldType = (): string => {
						let formFieldType = ''

						question.value.forEach((value: any) => {
							if (typeof value !== 'string') {
								if (value.name === condition.answer.name) {
									formFieldType = value.type
								}
							}
						})

						return formFieldType
					}

					if (formFieldType() === 'select') {
						return (userAnswerOfFormField === condition.answer.value)
					} else {
						if (typeof condition.answer.value === 'number') {
							userAnswerOfFormField = JSON.parse(userAnswerOfFormField)
						}

						switch (condition.answer.comparator) {
							case '<':
								return (userAnswerOfFormField < condition.answer.value)
								break
							case '<=':
								return (userAnswerOfFormField <= condition.answer.value)
								break
							case '>':
								return (userAnswerOfFormField > condition.answer.value)
								break
							case '>=':
								return (userAnswerOfFormField >= condition.answer.value)
								break
							case '!=':
								return (userAnswerOfFormField != condition.answer.value)
								break
							case '!==':
								return (userAnswerOfFormField !== condition.answer.value)
								break
							case '==':
								return (userAnswerOfFormField == condition.answer.value)
								break
							case '===':
								return (userAnswerOfFormField === condition.answer.value)
								break
							default: 
								return false
						}
					}
				}
			}
		})
		
		for (let i: number = 0; i < conditionsMet.length; i++) {
			if (!conditionsMet[i]) {
				return false;
			}
		}

		return true
	}
	toggleResult(resultIndex: number): void {
		Vue.set(this.resultsOpen, resultIndex, !this.resultsOpen[resultIndex])
	}

	mounted() {
		this.filteredResults.forEach((result: any, index: number) => {
			Vue.set(this.resultsOpen, index, false)
		})

		this.$store.dispatch('setQuestionVisited', (this.$store.getters.data.questions.length))
		
		window.scrollTo(0, 0)
	}
}
